import { Minus, Square, X } from 'lucide-react';

export function WindowControls() {
  const api = window.synthCohost;

  return (
    <div className="ml-1 flex items-center gap-1">
      <button
        type="button"
        aria-label="Minimize"
        onClick={() => api?.windowControls.minimize()}
        className="flex h-7 w-7 items-center justify-center rounded text-text-secondary hover:bg-surface-3 hover:text-text-primary"
      >
        <Minus className="h-3 w-3" />
      </button>
      <button
        type="button"
        aria-label="Maximize"
        onClick={() => api?.windowControls.toggleMaximize()}
        className="flex h-7 w-7 items-center justify-center rounded text-text-secondary hover:bg-surface-3 hover:text-text-primary"
      >
        <Square className="h-3 w-3" />
      </button>
      <button
        type="button"
        aria-label="Close"
        onClick={() => api?.windowControls.close()}
        className="flex h-7 w-7 items-center justify-center rounded text-text-secondary hover:bg-status-live hover:text-white"
      >
        <X className="h-3 w-3" />
      </button>
    </div>
  );
}
